"use client"

import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { CycListProps, RenderConfig } from "./RenderConfig"

export const CycList: ComponentConfig<CycListProps> = {
  label: "CaoCao | CycList",
  //@ts-ignore
  fields: {
    items: {
      label: "Items",
      type: "array",
      min: 1,
      getItemSummary: (item, index = 0) => `${index + 1}. ${item?.title || "Item"}`,
      arrayFields: {
        icon: {
          label: "Icon",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        link: {
          label: "Link",
          type: "text",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    items: [
      { icon: "", title: "Cycling Tours", link: "#" },
      { icon: "", title: "Walking tours", link: "#" },
      { icon: "", title: "Self-Guided Tours", link: "#" },
      { icon: "", title: "Customized Tours", link: "#" },
    ],
    className: "",
  },
  ...RenderConfig,
}
